export default {
  start: {
    en: 'Offer ends in',
  },
  time: {
    en: '{time}',
  },
}
